import React, { createContext, useContext, useState, useEffect } from "react";

import { useAuth } from "../AuthProvider/AuthProvider";

const AppContext = createContext();

export function useAppContext() {
  return useContext(AppContext);
}

export function AppProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const { loggedIn, setLoggedIn, user, setUser, useIAP, setUseIAP, clientClassName, setClientClassName } = useAuth();

  const value = {
    loading,
    setLoading,
    loggedIn,
    setLoggedIn,
    user,
    setUser,
    useIAP,
    setUseIAP,
    clientClassName,
    setClientClassName
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}
